module.exports = __webpack_public_path__ + "static/media/02.0624a682.jpg";